import { render } from "./VinculoFuncionalidade.vue?vue&type=template&id=afaf9c1e"
import script from "./VinculoFuncionalidade.vue?vue&type=script&lang=js"
export * from "./VinculoFuncionalidade.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__